import {
  DRIFT_SITE_CONCIERGE_DIMENSIONS,
  DRIFT_SITE_CONCIERGE_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const SiteConciergeContentCards: CubeQuery = {
  name: 'SiteConciergeContentCards',
  queryName: 'SiteConciergeContentCards',
  query: {
    measures: [
      DRIFT_SITE_CONCIERGE_MEASURES.COUNT_SC_LOADS,
      DRIFT_SITE_CONCIERGE_MEASURES.COUNT_CONTENT_PREVIEWS,
      DRIFT_SITE_CONCIERGE_MEASURES.COUNT_CONTENT_CLICKS,
    ],
  },
}

export const SiteConciergeContentTable: CubeQuery = {
  name: 'SiteConciergeContentTable',
  queryName: 'SiteConciergeContentTable',
  query: {
    measures: [
      DRIFT_SITE_CONCIERGE_MEASURES.COUNT_CONTENT_PREVIEWS,
      DRIFT_SITE_CONCIERGE_MEASURES.COUNT_CONTENT_CLICKS,
    ],
    dimensions: [DRIFT_SITE_CONCIERGE_DIMENSIONS.URL],
  },
}
